import { createSelector } from '@reduxjs/toolkit';
import { selectAvailableBanks } from './selectAvailableBanks';
import { mapBanksToOptions } from '../../utils/mappers';

export const selectBanksOptions = createSelector(selectAvailableBanks, state => {
  return mapBanksToOptions(state);
});
